import axios from 'axios';

// FIXED: Clean condition that forces your live URL on the production build 
const BASE_URL = 
  window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
    ? 'http://localhost:5001' // Local Dev URL
    : 'https://api.swiftofficesupply.co.ke'; // Production API URL

const API = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Automatically inject Authorization token if available
API.interceptors.request.use((config) => {
  const token = localStorage.getItem('token'); 
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

console.log("Current API Base URL:", BASE_URL);

export default API;